import { useCallback, useEffect, useState, useMemo } from 'react';
import { countThongKe, getUserBds, listProductIDShow } from '../../../services/apiBds';
import {
  Button,
  Card,
  CardBody,
  Chip,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  IconButton,
} from '@material-tailwind/react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';
import { Link } from 'react-router-dom';
import ExportExcel from './exportExcel';
import { decode, encode } from '../../../utils/helper';
import images from '../../../assets/images';
import FrameShowBds from '../../../components/FrameShowBds';

// Component con quản lý phân trang nội bộ cho mỗi bảng dữ liệu
function LocalPaginationList({ data, itemsPerPage = 20, renderItem }) {
  const [currentPage, setCurrentPage] = useState(1);

  // Reset trang về 1 khi dữ liệu tìm kiếm thay đổi
  useEffect(() => setCurrentPage(1), [data]);

  const totalPages = Math.ceil(data.length / itemsPerPage);
  const currentData = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return data.slice(start, start + itemsPerPage);
  }, [data, currentPage, itemsPerPage]);

  if (!data || data.length === 0) return null;

  return (
    <div>
      <div className="min-h-[100px]">{currentData.map((item, i) => renderItem(item, i))}</div>
      {totalPages > 1 && (
        <div className="flex items-center justify-center gap-4 mt-4 border-t pt-2">
          <IconButton
            size="sm"
            variant="outlined"
            onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
            disabled={currentPage === 1}
          >
            <ChevronLeftIcon className="h-4 w-4" />
          </IconButton>
          <span className="text-sm font-medium">
            Trang {currentPage} / {totalPages}
          </span>
          <IconButton
            size="sm"
            variant="outlined"
            onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
            disabled={currentPage === totalPages}
          >
            <ChevronRightIcon className="h-4 w-4" />
          </IconButton>
        </div>
      )}
    </div>
  );
}

function Thongke() {
  const [arrTk, setArrTk] = useState({});
  const [arrBDSUser, setArrBDSUser] = useState([]);
  const [loading, setLoading] = useState(true);
  const [objBoLoc, setObjBoLoc] = useState({ ngaycapnhatstart: '', ngaycapnhatend: '', username: '', idbds: '' });
  const [open, setOpen] = useState(false);
  const [showImages, setShowImages] = useState('');
  const [showBdsId, setShowBdsId] = useState({});
  const [openShowBdsID, setOpenShowBdsID] = useState(false);

  const listAllThongKe = useCallback(async (date = '', username = '', id = '') => {
    setLoading(true);
    const cleanId = id.startsWith('#') ? decode(id.slice(1)) : decode(id);
    const resultAPI = await countThongKe(date, username, cleanId);
    setArrTk(resultAPI || {});
    setLoading(false);
  }, []);

  useEffect(() => {
    listAllThongKe();
  }, [listAllThongKe]);

  const listBdsAll = async (pages = 1, code = '') => {
    setLoading(true);
    const resultBDSAll = await listProductIDShow(pages, '', code);
    if (resultBDSAll?.length > 0) {
      setShowBdsId(resultBDSAll[0]);
      setShowImages(resultBDSAll[0]?.anhto?.split(',').map((s) => s.trim()));
      setOpenShowBdsID(true);
    }
    setLoading(false);
  };

  const getIDBDS = async (username = '', id = '', truong = '') => {
    setArrBDSUser([]);
    setLoading(true);
    const resultAPI = await getUserBds(username, id, truong);
    setArrBDSUser(resultAPI || []);
    setLoading(false);
    setOpen(true);
  };

  const handleSub = () => {
    const date = objBoLoc.ngaycapnhatstart ? `${objBoLoc.ngaycapnhatstart},${objBoLoc.ngaycapnhatend}` : '';
    listAllThongKe(date, objBoLoc.username, objBoLoc.idbds);
  };

  // Helper render cho các dòng dữ liệu - ĐÃ FIX THAM SỐ truong
  const renderRow = (row, i, typeColor, truong) => (
    <div
      key={i}
      className="text-sm flex items-center gap-2 whitespace-nowrap mb-2 border-b border-gray-50 pb-1 hover:bg-gray-50"
    >
      <span onClick={() => listBdsAll(1, row.id_bds)} className="cursor-pointer hover:text-red-500 font-medium">
        Mã #{encode(row?.id_bds)}
      </span>{' '}
      |<b className="text-teal-600 ml-1">User: {row?.username}</b> |
      <b className={`text-${typeColor}-500`}>{row?.view} lượt</b> |
      <Link to={`/bds/${encode(row.id_bds)}`} target="_blank" className="text-xs text-gray-500 hover:text-blue-500">
        xem tin
      </Link>{' '}
      |
      <span
        className="text-white text-[10px] px-2 py-0.5 bg-green-500 cursor-pointer rounded-full font-bold hover:bg-green-600 transition-colors"
        onClick={() => getIDBDS(row?.username, row.id_bds, truong)}
      >
        thời gian
      </span>
      <span className="text-gray-400 text-[11px]">| {row?.create_date?.split('T')[0]}</span>
    </div>
  );

  return (
    <div className="grid grid-cols-1 gap-4 p-2">
      {loading && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/70 backdrop-blur-sm">
          <div className="relative w-24 h-24">
            <div className="absolute inset-0 rounded-full border-4 border-orange-500 border-t-transparent animate-spin"></div>
            <img src={images.logoklandload} alt="Logo" className="absolute inset-4 w-16 h-16 object-contain" />
          </div>
        </div>
      )}

      {/* Bộ lọc */}
      <Card className="border border-gray-200 shadow-sm">
        <CardBody className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3 items-end p-4">
          <div>
            <label className="text-xs font-bold mb-1 block">MÃ BĐS</label>
            <Input
              size="md"
              value={objBoLoc.idbds}
              onChange={(e) => setObjBoLoc({ ...objBoLoc, idbds: e.target.value })}
              labelProps={{ className: 'hidden' }}
            />
          </div>
          <div>
            <label className="text-xs font-bold mb-1 block">USERNAME</label>
            <Input
              size="md"
              value={objBoLoc.username}
              onChange={(e) => setObjBoLoc({ ...objBoLoc, username: e.target.value })}
              labelProps={{ className: 'hidden' }}
            />
          </div>
          <div>
            <label className="text-xs font-bold mb-1 block">TỪ NGÀY</label>
            <Input
              type="date"
              size="md"
              value={objBoLoc.ngaycapnhatstart}
              onChange={(e) => setObjBoLoc({ ...objBoLoc, ngaycapnhatstart: e.target.value })}
              labelProps={{ className: 'hidden' }}
            />
          </div>
          <div>
            <label className="text-xs font-bold mb-1 block">ĐẾN NGÀY</label>
            <Input
              type="date"
              size="md"
              value={objBoLoc.ngaycapnhatend}
              onChange={(e) => setObjBoLoc({ ...objBoLoc, ngaycapnhatend: e.target.value })}
              labelProps={{ className: 'hidden' }}
            />
          </div>
          <Button color="orange" onClick={handleSub} className="h-10">
            Tìm kiếm
          </Button>
        </CardBody>
      </Card>

      {/* Danh sách thống kê chi tiết */}
      <div className="grid grid-cols-1 gap-4">
        {[
          { key: 'tkso', label: 'Xem Sổ', color: 'blue', truong: 'xemso' },
          { key: 'tksdt', label: 'Xem SĐT', color: 'red', truong: 'xemsdt' },
          { key: 'tkhinh', label: 'Tải Hình', color: 'green', truong: 'taihinh' },
        ].map(
          (item) =>
            arrTk?.[item.key]?.arr?.length > 0 && (
              <Card key={item.key} className="border border-gray-200">
                <CardBody className="p-4">
                  <h6 className={`font-bold text-${item.color}-800 uppercase mb-3`}>
                    Thống kê {item.label} (THEO USER)
                    {/* - {arrTk[item.key].arr.length} luot */}
                  </h6>
                  <LocalPaginationList
                    data={arrTk[item.key].arr}
                    renderItem={(row, i) => renderRow(row, i, item.color, item.truong)}
                  />
                </CardBody>
              </Card>
            ),
        )}
      </div>

      {/* Thống kê tổng quát */}
      <Card className="border border-gray-200 shadow-sm">
        <CardBody className="p-4">
          <div className="flex justify-between items-center mb-4 border-b pb-2">
            <h5 className="font-bold text-lg">THỐNG KÊ TỔNG QUÁT</h5>
            <ExportExcel
              data={arrTk}
              date={objBoLoc.ngaycapnhatstart ? `${objBoLoc.ngaycapnhatstart}_${objBoLoc.ngaycapnhatend}` : ''}
            />
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {[
              { key: 'tkso', label: 'TK SỔ', color: 'blue', truong: 'xemso' },
              { key: 'tksdt', label: 'TK SĐT', color: 'red', truong: 'xemsdt' },
              { key: 'tkhinh', label: 'TK HÌNH', color: 'green', truong: 'taihinh' },
            ].map(
              (item) =>
                arrTk?.[item.key]?.total?.length > 0 && (
                  <div key={item.key} className="p-3 bg-gray-50 rounded-lg border border-gray-100">
                    <div className="flex justify-between mb-2 items-center">
                      <span className={`font-bold text-sm text-${item.color}-700 uppercase`}>{item.label}</span>
                      <Chip size="sm" value={arrTk[item.key].sum} color="blue-gray" variant="ghost" />
                    </div>
                    <LocalPaginationList
                      data={arrTk[item.key].total}
                      itemsPerPage={10}
                      renderItem={(row, i) => (
                        <div key={i} className="text-xs flex justify-between py-1.5 border-b border-white">
                          <span
                            className="cursor-pointer text-blue-500 hover:text-orange-700 font-medium"
                            onClick={() => listBdsAll(1, row.id_bds)}
                          >
                            Mã #{encode(row.id_bds)}
                          </span>
                          <div className="flex items-center gap-2">
                            <b>{row.view} lượt</b>
                            <span
                              className="text-[9px] bg-white border px-1 rounded cursor-pointer hover:bg-gray-100 font-bold"
                              onClick={() => getIDBDS('', row.id_bds, item.truong)}
                            >
                              Chi Tiết
                            </span>
                          </div>
                        </div>
                      )}
                    />
                  </div>
                ),
            )}
          </div>
        </CardBody>
      </Card>

      {/* Modal chi tiết thời gian */}
      <Dialog open={open} handler={() => setOpen(false)} size="sm">
        <DialogHeader className="text-blue-gray-800">Chi tiết lịch sử</DialogHeader>
        <DialogBody divider className="overflow-y-auto max-h-[400px]">
          <LocalPaginationList
            data={arrBDSUser}
            itemsPerPage={15}
            renderItem={(row, i) => (
              <div key={i} className="text-sm mb-2 pb-1 border-b border-gray-100 last:border-0">
                <div className="flex justify-between items-center">
                  <span className="font-bold text-orange-800">{row.username || 'N/A'}</span>
                  <span className="text-[10px] text-gray-400">{row.create_date}</span>
                </div>
                <div className="text-gray-600 text-xs mt-1">{row.noidung}</div>
              </div>
            )}
          />
        </DialogBody>
        <DialogFooter>
          <Button variant="text" color="red" onClick={() => setOpen(false)}>
            Đóng
          </Button>
        </DialogFooter>
      </Dialog>

      {/* Modal FrameShowBds */}
      <Dialog open={openShowBdsID} handler={() => setOpenShowBdsID(false)} size="xl">
        <DialogBody className="overflow-y-auto max-h-[85vh] p-0">
          <FrameShowBds data={showBdsId} Avt={showBdsId?.avt} showImages={showImages} />
        </DialogBody>
      </Dialog>
    </div>
  );
}

export default Thongke;
